import type { ReactNode } from "react";
import { getGameMetadata } from "modules/common/gameRegistry";
import { GameIcon } from "modules/common/components/Icons/GameIcon";

export function GameDivider({ game }: { game: string }) {
  const metadata = getGameMetadata(game);
  return (
    <div className="text-base-content/40 flex items-center gap-2 px-1 py-1 text-xs">
      <div className="bg-base-content/10 h-px flex-1" />
      <span className="flex items-center gap-1">
        <GameIcon game={game} size={16} />
        {metadata.shortName}
      </span>
      <div className="bg-base-content/10 h-px flex-1" />
    </div>
  );
}

export function GameGroupWrapper({
  game,
  children,
}: {
  game: string;
  children: ReactNode;
}) {
  const accent = getGameMetadata(game).presentation.facetAccentClass;
  return <div className={`border-l-2 ${accent} ml-1 pl-2`}>{children}</div>;
}
